import { useState, useEffect } from 'react'
import { getConteudoChave, CONTEUDO_CHAVES } from '@/api/adminApi'
import { useRequireConteudoFlag } from '@/utils/featureFlags'
import { ClientPageLayout, clientPageStyles as layout } from '@/components/ClientPageLayout'
import { resolveMediaUrl } from '@/utils/mediaUrl'
import styles from './QuemSomosPage.module.css'

export function QuemSomosPage() {
  const { loading: featureLoading } = useRequireConteudoFlag(CONTEUDO_CHAVES.menu_show_quem_somos)
  const [conteudo, setConteudo] = useState('')
  const [imagemUrl, setImagemUrl] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    Promise.all([
      getConteudoChave(CONTEUDO_CHAVES.quem_somos),
      getConteudoChave(CONTEUDO_CHAVES.quem_somos_imagem_url).catch(() => null),
    ])
      .then(([texto, img]) => {
        if (cancelled) return
        setConteudo(texto ?? '')
        setImagemUrl((img ?? '').trim())
      })
      .catch(() => {
        if (!cancelled) {
          setConteudo('')
          setImagemUrl('')
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const texto = conteudo.trim()
  const imagem = imagemUrl.trim()
  const hasContent = texto.length > 0 || imagem.length > 0
  const imgSrc = imagem ? resolveMediaUrl(imagem) : ''

  if (featureLoading) return null

  return (
    <ClientPageLayout
      loading={loading}
      empty={!hasContent}
      emptyMessage="A nossa história e imagem serão publicadas em breve."
      emptyIcon="✨"
    >
      <div className={styles.page}>
        {imagem && (
          <div className={styles.hero}>
            <div className={styles.heroAspect}>
              <img className={styles.heroImg} src={imgSrc} alt="" />
              <div className={styles.heroShine} aria-hidden />
              <div className={styles.heroFade} aria-hidden />
            </div>
          </div>
        )}

        <div
          className={`${layout.card} ${styles.contentCard} ${imagem ? styles.contentCardTightTop : ''}`.trim()}
        >
          <p className={layout.lead}>Conheça quem cuida de si com dedicação.</p>
          {texto ? (
            <div
              className={layout.prose}
              dangerouslySetInnerHTML={{ __html: conteudo.replace(/\n/g, '<br />') }}
            />
          ) : (
            imagem && <p className={styles.placeholderOnlyImage}>Em breve: mais detalhes sobre a nossa equipa e valores.</p>
          )}
        </div>
      </div>
    </ClientPageLayout>
  )
}
